import { useEffect, useState } from 'react';

export type Platform = 'mac' | 'windows' | 'linux' | 'unknown';

export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>('unknown');

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform?.toLowerCase() || '';

    if (platform.includes('mac') || userAgent.includes('mac')) {
      setPlatform('mac');
    } else if (platform.includes('win') || userAgent.includes('win')) {
      setPlatform('windows');
    } else if (platform.includes('linux') || userAgent.includes('linux')) {
      setPlatform('linux');
    } else {
      setPlatform('unknown');
    }
  }, []);

  return platform;
}

export function isMac(): boolean {
  if (typeof window === 'undefined') return false;
  const platform = navigator.platform?.toLowerCase() || '';
  const userAgent = navigator.userAgent.toLowerCase();
  return platform.includes('mac') || userAgent.includes('mac');
}

export function getModifierKey(): string {
  return isMac() ? 'Cmd' : 'Alt';
}

export function getModifierKeySymbol(): string {
  return isMac() ? '⌘' : 'Alt';
}
